/** Game locks at kickoff (UTC). */
export function isLocked(kickoffUtc: string, now: Date = new Date()): boolean {
  const kickoff = Date.parse(kickoffUtc);
  if (Number.isNaN(kickoff)) return true;
  return now.getTime() >= kickoff;
}

/** Kickoff clock only — the date heading already names the day. */
export function formatKickoffClock(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'America/New_York',
    timeZoneName: 'short',
  });
}
